// import '@google/model-viewer';
// import React, { useRef, useEffect } from 'react';
// import sliderimg from '../images/newtest.glb';

// const Glb = () => {
//   const modelViewerRef = useRef();

//   useEffect(() => {
//     const modelViewer = modelViewerRef.current;
//     const applyColor = () => {
//       const material = modelViewer.model?.materials?.[0];
//       if (material) {
//         material.pbrMetallicRoughness.setBaseColorFactor([0.235, 0.235, 0.235, 1]);
//         material.pbrMetallicRoughness.setMetallicFactor(1.0);
//         material.pbrMetallicRoughness.setRoughnessFactor(0.25);
//       }
//     };
//     modelViewer.addEventListener('load', applyColor);
//     return () => {
//       modelViewer.removeEventListener('load', applyColor);
//     };
//   }, []);

//   return (
//     <div style={{ width: '100%', height: 'auto', maxWidth: '100%', aspectRatio: '16 / 12' }}>
//       <model-viewer
//         ref={modelViewerRef}
//         src={sliderimg}
//         alt="3D model"
//         auto-rotate
//         camera-controls
//         disable-zoom
//         style={{ width: '100%', height: '100%' }}
//         exposure="1"
//         ar
//         ar-modes="webxr scene-viewer quick-look"
//         poster="poster.webp"
//         shadow-intensity="1"
//       >
//         <button
//           className="Hotspot"
//           slot="hotspot-1"
//           data-position="50m 34.956m 67.563m"
//           data-normal="1m 0m 0m"
//           data-visibility-attribute="visible"
//           tabIndex={0}
//         >
//           <div className="HotspotAnnotation top-left">30+ Years of Precision Engineering Expertise</div>
//         </button>
//         <button
//           className="Hotspot"
//           slot="hotspot-2"
//           data-position="50.000m -80.347m -22.500m"
//           data-normal="1m 0m 0m"
//           data-visibility-attribute="visible"
//           tabIndex={0}
//         >
//           <div className="HotspotAnnotation bottom-right">Custom Tools, Dies, Jigs &amp; Fixtures</div>
//         </button>
//         <button
//           className="Hotspot"
//           slot="hotspot-3"
//           data-position="50.350m 8.267m -88.740m"
//           data-normal="0.891m -0.054m 0.451m"
//           data-visibility-attribute="visible"
//           tabIndex={0}
//         >
//           <div className="HotspotAnnotation bottom-left">Fast Turnaround &amp; Reliable Support</div>
//         </button>
//       </model-viewer>

//       <style jsx>{`
//         .Hotspot {
//           background: #2b2f36cc;
//           border-radius: 50%;
//           width: clamp(14px, 2vw, 20px);
//           height: clamp(14px, 2vw, 20px);
//           border: 2px solid white;
//           cursor: pointer;
//           animation: pulse 2s infinite, float 3s ease-in-out infinite;
//         }

//         .HotspotAnnotation {
//           position: absolute;
//           background: rgba(0, 0, 0, 0.75);
//           color: white;
//           padding: 6px 10px;
//           border-radius: 5px;
//           white-space: nowrap;
//            font-size: 10px; 
//           font-size: clamp(10px, 2vw, 14px);
//           pointer-events: none;
//           opacity: 1;
//           transition: opacity 0.3s ease;
//         }

//         /* Responsive offset positioning to reduce overlap */
//         .top-left {
//           top: -30px;
//           left: 25px;
//         }
//         .bottom-right {
//           bottom: -30px;
//           right: 25px;
//         }
//         .bottom-left {
//          bottom: -40px;
//         left: -95px;
//         }

//     @keyframes pulse {
//           0% {
//             box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
//           }
//           70% {
//             box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
//           }
//           100% {
//             box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
//           }
//         }

//         @keyframes float {
//           0% {
//             transform: translateY(0);
//           }
//           50% {
//             transform: translateY(-5px);
//           }
//           100% {
//             transform: translateY(0);
//           }
//         }

//         @media (max-width: 768px) {
//           .HotspotAnnotation {
//             font-size: 11px;
//             padding: 4px 8px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Glb;




import '@google/model-viewer';
import React, { useRef, useEffect } from 'react';
import sliderimg from '../images/newtest.glb';

const Glb = () => {
  const modelViewerRef = useRef();

  useEffect(() => {
    const modelViewer = modelViewerRef.current;
    const applyColor = () => {
      const material = modelViewer.model?.materials?.[0];
      if (material) {
        material.pbrMetallicRoughness.setBaseColorFactor([0.235, 0.235, 0.235, 1]);
        material.pbrMetallicRoughness.setMetallicFactor(1.0);
        material.pbrMetallicRoughness.setRoughnessFactor(0.25);
      }
    };
    modelViewer.addEventListener('load', applyColor);
    return () => {
      modelViewer.removeEventListener('load', applyColor);
    };
  }, []);

  return (
    <div style={{ width: '100%', maxWidth: '100%', aspectRatio: '16 / 12' }}>
      {/* <model-viewer
        ref={modelViewerRef}
        src={sliderimg}
        alt="3D model"
        auto-rotate
        camera-controls
        disable-zoom
        disable-tap
        interaction-prompt="none"
        style={{ width: '100%', height: '100%' }}
        exposure="1"
        ar
        ar-modes="webxr scene-viewer quick-look"
        poster="poster.webp"
        shadow-intensity="1"
      >
        <button
          className="Hotspot"
          slot="hotspot-1"
          data-position="50m 34.956m 67.563m"
          data-normal="1m 0m 0m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation top-left">30+ Years of Precision Engineering Expertise</div>
        </button>
        <button
          className="Hotspot"
          slot="hotspot-2"
          data-position="50.000m -80.347m -22.500m"
          data-normal="1m 0m 0m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation bottom-right">Custom Tools, Dies, Jigs &amp; Fixtures</div>
        </button>
        <button
          className="Hotspot"
          slot="hotspot-3"
          data-position="50.350m 8.267m -88.740m"
          data-normal="0.891m -0.054m 0.451m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation bottom-left">Fast Turnaround &amp; Reliable Support</div>
        </button>
        <button
          className="Hotspot"
          slot="hotspot-4"
          data-position="10m 8.267m -88.740m"
          data-normal="1m 0m 0m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation">Machining capability up to 0.005mm/0.0002</div>
        </button>

      </model-viewer> */}
      <model-viewer
        ref={modelViewerRef}
        src={sliderimg}
        alt="3D model"
        auto-rotate
        camera-controls
        disable-zoom
        disable-tap
        interaction-prompt="none"
        style={{ width: '100%', height: '100%' }}
        exposure="1"
        ar
        ar-modes="webxr scene-viewer quick-look"
        poster="poster.webp"
        shadow-intensity="1"
      >
        <button
          className="Hotspot"
          slot="hotspot-1"
          data-position="59.8653255305083m 39.02570330245437m 82.62135382970091m"
          data-normal="0.9876779788570802m -0.06613970127113067m -0.14183705438480745m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation top-left">30+ Years of Precision Engineering Expertise</div>
        </button>
        <button
          className="Hotspot"
          slot="hotspot-2"
          data-position="49.99999999999994m 37.17007834449006m -76.65050979004984m"
          data-normal="1m 0m 0m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation bottom-right">Custom Tools, Dies, Jigs &amp; Fixtures</div>
        </button>
        <button
          className="Hotspot"
          slot="hotspot-3"
          data-position="54.268067022613764m -53.054809925873236m 71.87551103841174m"
          data-normal="0.008240718842758423m 0.6067798390958531m -0.794827224885865m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation bottom-left">Fast Turnaround &amp; Reliable Support</div>
        </button>
        <button
          className="Hotspot"
          slot="hotspot-4"
          data-position="49.999999999999886m -33.60858951523369m -61.267190473144794m"
          data-normal="1m 0m 0m"
          data-visibility-attribute="visible"
          tabIndex={0}
        >
          <div className="HotspotAnnotation">Machining capability up to 0.005mm/0.0002</div>
        </button>
      </model-viewer>


      <style jsx>{`
        .Hotspot {
          all: unset;
          display: block;
          position: relative;
          background: #2b2f36cc;
          border-radius: 50%;
          width: clamp(14px, 2vw, 20px);
          height: clamp(14px, 2vw, 20px);
          border: 2px solid white;
          cursor: pointer;
          animation: pulse 2s infinite, float 3s ease-in-out infinite;
        }

        .Hotspot:focus {
          outline: none;
          box-shadow: none;
        }

        .HotspotAnnotation {
          position: absolute;
          background: rgba(0, 0, 0, 0.75);
          color: white;
          font-size: 11px !important;
          padding: 6px 10px;
          border-radius: 5px;
          white-space: nowrap;
          font-size: clamp(10px, 2vw, 14px);
          pointer-events: none;
          opacity: 1;
          transition: opacity 0.3s ease;
        }

        .top-left {
          top: -30px;
          left: 25px;
        }
        .bottom-right {
          bottom: -30px;
          right: 25px;
        }
        .bottom-left {
          bottom: -40px;
          left: -95px;
        }

        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
          }
          70% {
            box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
          }
        }

        @keyframes float {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .HotspotAnnotation {
            font-size: 11px;
            padding: 4px 8px;
          }
        }
      `}</style>
    </div>
  );
};

export default Glb;
